import { VIEWPORT } from 'constants';
import { useViewport } from './index';

/**
 * Hook for checking mobile viewport depending on the current window size
 */
const useMobileViewport = () => useViewport() === VIEWPORT.MOB;

export default useMobileViewport;
